import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-help',
  templateUrl: './payment-help.component.html',
  styleUrls: ['./payment-help.component.css']
})
export class PaymentHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
